<template>
  <v-container fluid class="pa-0">
    <Slider1 :slider-content="slider"/>
    <!--template v-if="$store.getters.getAppPartners.length === 1">
      <DeviceFinder />
    </template>
    <template v-else>
      <PartnersContainer :description="partnerContainer.description"
                         :title="partnerContainer.title"/>
    </template-->
  </v-container>
</template>

<script>
import DeviceFinder from '@/components/device/DeviceFinder.vue';
import InnerNavBar from 'src/components/navigation/InnerNavBar.vue';
import PartnersContainer from 'src/components/general/PartnersContainer.vue';
import SideBySideList from '@/components/general/SideBySideList.vue';
import Slider1 from '@/components/slider/Slider1.vue';
import SlideGroup from '@/components/general/SlideGroup.vue';

export default {
  name: 'Home',
  components: {
    DeviceFinder, InnerNavBar, PartnersContainer, SideBySideList, Slider1, SlideGroup,
  },
  props: {
    //
  },
  data() {
    return {
      partnerContainer: {
        title: 'Válaszd ki, melyik partnerünknél szeretnél új Galaxy Z Fold3 vagy Galaxy Z Flip3 készüléket vásárolni!',
        description: 'A kedvezményt különböző módon tudod érvényesíteni. Válaszd ki a kiszemelt online üzletet és '
          + 'végig vezetünk, hogy néhány egyszerű lépésben kihasználd a Samsung által kínált promóciós kedvezményt.',
      },
      slider: {
        backgroundBottomColor: '#FAFAFA',
        backgroundTopColor: '#FFFFFF',
        button: {
          align: 'left',
          isExternal: false,
          isVisible: false,
          link_url: 'partnerHome-cashback',
          link_params: { partnerName: 'kalkulacio' },
          text: 'Kalkuláció',
        },
        description: 'A már leadott igényeket természetesen feldolgozzuk és kezelni fogjuk!<br>Érdeklődni a leadott igényekkel kapcsolatban az info@tmx.hu e-mail címen tudnak.',
        mob_img_path: '',
        //mob_img_path: 'images/borito20220811.png',
        order: 'imgToRight',
        pc_img_path: '',
        //pc_img_path: 'images/borito20220811.png',
        subtitle: 'Tájékoztatjuk Önöket, hogy a TMX Mobile Solution Szerviz Kft. 2023. december 27-én megszüntette a weboldalon nyújtott szolgáltatását!',
        textAlign: 'text-left',
        title: 'FIGYELEM!',
        titleUppercase: false,
        titleWeight: 'regular',
      }
    };
  },
  methods: {
    //
  },
};
</script>
